import React, { useEffect, useState } from 'react';
// ─── Icon primitives (no external deps) ──────────────────────────────────────
/** Heroicons / mini — x-mark */
function XMarkIcon() {
    return (React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", width: 14, height: 14 },
        React.createElement("path", { d: "M4 4l12 12M16 4L4 16" })));
}
function TrashIcon() {
    return (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", width: 14, height: 14 },
        React.createElement("path", { d: "M2 4h12" }),
        React.createElement("path", { d: "M6 4V2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V4" }),
        React.createElement("path", { d: "M3 4l.8 9.2a1 1 0 0 0 1 .8h6.4a1 1 0 0 0 1-.8L13 4" }),
        React.createElement("path", { d: "M6.5 7v4.5M9.5 7v4.5" })));
}
// ─── Component ───────────────────────────────────────────────────────────────
export function TierRow(_a) {
    var tier = _a.tier, isLast = _a.isLast, isOnly = _a.isOnly, currency = _a.currency, onToggle = _a.onToggle, onUpdateMaxPax = _a.onUpdateMaxPax, onUpdatePrice = _a.onUpdatePrice, onDelete = _a.onDelete;
    var id = tier.id, minPax = tier.minPax, maxPax = tier.maxPax, price = tier.price, enabled = tier.enabled;
    // Max pax input value: null → "∞"  (open-ended last tier)
    var maxPaxDisplay = maxPax === null ? '∞' : String(maxPax);
    var _b = useState(maxPax === null ? '' : String(maxPax)), maxPaxDraft = _b[0], setMaxPaxDraft = _b[1];
    useEffect(function () {
        setMaxPaxDraft(maxPax === null ? '' : String(maxPax));
    }, [maxPax]);
    function handleMaxPaxChange(e) {
        var raw = e.target.value;
        setMaxPaxDraft(raw);
        if (raw === '')
            return; // deja el campo vacío mientras se edita
        var parsed = parseInt(raw, 10);
        if (!isNaN(parsed) && parsed >= minPax) {
            onUpdateMaxPax(parsed);
        }
    }
    function handleMaxPaxBlur() {
        var parsed = parseInt(maxPaxDraft, 10);
        if (isNaN(parsed) || parsed < minPax) {
            // valor inválido o vacío al perder el foco → revertir al último válido
            setMaxPaxDraft(maxPax === null ? '' : String(maxPax));
        }
    }
    function handlePriceChange(e) {
        onUpdatePrice(e.target.value);
    }
    return (React.createElement("tr", { className: enabled ? '' : 'tier-disabled' },
        React.createElement("td", { className: "cell-check" },
            React.createElement("input", { type: "checkbox", className: "pt-checkbox", checked: enabled, onChange: onToggle, id: "tier-enabled-".concat(id), "aria-label": "Enable tier for pax ".concat(minPax, "\u2013").concat(maxPaxDisplay) })),
        React.createElement("td", null,
            React.createElement("div", { className: "range-group" },
                React.createElement("input", { type: "number", className: "pt-input", value: minPax, readOnly: true, "aria-label": "Minimum passengers", id: "tier-min-".concat(id) }),
                React.createElement("span", { className: "range-separator" }, "\u2013"),
                isLast ? (React.createElement("input", { type: "text", className: "pt-input is-open", value: maxPaxDisplay, readOnly: true, "aria-label": "Maximum passengers (open-ended)", id: "tier-max-".concat(id) })) : (React.createElement("input", { type: "number", className: "pt-input border-secondary border rounded", value: maxPaxDraft, min: minPax, onChange: handleMaxPaxChange, onBlur: handleMaxPaxBlur, "aria-label": "Maximum passengers", id: "tier-max-".concat(id) })))),
        React.createElement("td", null,
            React.createElement("div", { className: "price-wrapper" },
                React.createElement("span", { className: "price-currency" }, currency),
                React.createElement("input", { type: "number", className: "pt-price-input border-secondary border rounded", value: price >= -1 ? String(price) : '', min: 0, step: 0.01, 
                    // placeholder="0.00"
                    onChange: handlePriceChange, "aria-label": "Price for tier ".concat(minPax, "\u2013").concat(maxPaxDisplay), id: "tier-price-".concat(id) }))),
        React.createElement("td", { className: "cell-delete" },
            React.createElement("button", { type: "button", className: "pt-delete-btn", onClick: onDelete, "aria-label": "Remove tier ".concat(minPax, "\u2013").concat(maxPaxDisplay), title: "Remove tier" },
                React.createElement(TrashIcon, null)))));
}



//////////////////
// WEBPACK FOOTER
// ./src/components/PricingTier/TierRow.tsx
// module id = 1021
// module chunks = 0